export const mainQueryResultHeadCells = [
    {id: 'studentId', label: 'Student ID'},
    {id: 'firstName', label: 'First Name'},
    {id: 'lastName', label: 'Last Name'},
    {id: 'phoneNumber', label: 'Phone Number'},
    {id: 'email', label: 'Email Address'},
    {id: 'course', label: 'Course'},
    {id: 'actions', label: 'Actions', disableSorting: true}
]


export const detailedViewHeadCells = [
    {id: 'category', label: 'Category'},
    {id: 'data', label: 'Data'},
]

export const detailedViewColumnCells = [
    {id: 'studentId', label: 'Student ID'},
    {id: 'firstName', label: 'First Name'},
    {id: 'lastName', label: 'Last Name'},
    {id: 'phoneNumber', label: 'Phone Number'},
    {id: 'email', label: 'Email Address'},
    {id: 'mailingAddress', label: 'Mailing Address'},
    {id: 'course', label: 'Course'},
    {id: 'rotation', label: 'Rotation'},
    {id: 'startDate', label: 'Start Date'},
    {id: 'completionDate', label: 'Completion Date'},
    {id: 'dateEnrollmentAgreementSigned', label: 'Agreement Signed Date'},
    {id: 'thirdPartyPayerInfo', label: 'Third Party Payer Info'},
    {id: 'courseCost', label: 'Course Cost'},
    {id: 'chargesCharged', label: 'Total Charges'},
    {id: 'chargesPaid', label: 'Total Paid'},
    {id: 'paid', label: 'Paid'},
    {id: 'graduated', label: 'Graduated'},
    {id: 'passedFirstExam', label: 'Passed First Exam'},
    {id: 'passedSecondOrThird', label: 'Passed Second or Third Exam'},
    {id: 'employed', label: 'Employed'},
    {id: 'position', label: 'Position'},
    {id: 'placeOfEmployment', label: 'Place of Employment'},
    {id: 'employmentAddress', label: 'Employment Address'},
    {id: 'startingWage', label: 'Starting Wage'},
    {id: 'hoursWorked', label: 'Hours Worked Weekly'},
    {id: 'descriptionAttempts', label: 'Comments'}]